import { Alert, Box, Button, Card, Text, Title } from '@nimbus-ds/components';
import { useAsyncFunc } from 'commons/hooks';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';

interface CardInvoiceProps {
  hasCompleteCustomerInfo: boolean;
  isValidInvoiceStatus: boolean;
  onSubmit: () => void;
}

function CardInvoice({
  hasCompleteCustomerInfo,
  isValidInvoiceStatus,
  onSubmit,
}: CardInvoiceProps) {
  const t = useTranslationOrders();

  const [handleInvoiceRequest] = useAsyncFunc(async () => onSubmit());

  const isInvoiceIssueAvailable = !!(
    isValidInvoiceStatus && hasCompleteCustomerInfo
  );

  return (
    <Card>
      <Card.Header>
        <Title as="h4">{t('cardInvoice.title')}</Title>
      </Card.Header>

      {isInvoiceIssueAvailable && (
        <Box display="flex" flexDirection="row" flex="1">
          <Button appearance="neutral" onClick={() => handleInvoiceRequest()}>
            {t('cardInvoice.button.issue')}
          </Button>
        </Box>
      )}

      {!isValidInvoiceStatus && (
        <Text fontSize="base" color="neutral-textLow">
          {t('cardInvoice.unpacked')}
        </Text>
      )}

      <Alert
        title={t('cardInvoice.alert.missingCustomerInfo.title')}
        appearance="warning"
        show={!hasCompleteCustomerInfo}
      >
        <Text fontSize="base" fontWeight="regular">
          {t('cardInvoice.alert.missingCustomerInfo.message')}
        </Text>
      </Alert>
    </Card>
  );
}

export default CardInvoice;
